module.exports = __webpack_public_path__ + "img/evaluateIcon02.b1d62040.png";